<template>
	<c-dialog ref="dialog" mode="slide" width="70vw" mask-close>
		<c-form vertical unit-width="100%" column="2">
			<c-form-item label="销售客户" required>
				<template #handle>
					<c-link icon="tf-add" @click="createCustomer">新建客户</c-link>
				</template>
				<c-select ref="customerSelect" v-model="customerId" async @search="searchCustomer" :value-data="customerOptions" placeholder="请选择" style="flex: 1;"></c-select>
			</c-form-item>
			<c-form-item label="备注">
				<c-input v-model="remark" placeholder="请输入备注" maxlength="200"></c-input>
			</c-form-item>
			<c-title>商品明细</c-title>
			<c-form-item :label="false" colspan="2">
                <m-operate border>
                    <c-input ref="codeInput" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanHandle" :disabled="orderId && productList.length >= 1">
                        <template #appendIcon><i class="tf-scan"></i></template>
                    </c-input>
                    <c-button color="main" @click="scanHandle" :disabled="orderId && productList.length >= 1">确定</c-button>
                </m-operate>
				<c-table :data="productList" border :paging="false">
                    <template #empty>
                        <c-empty message="请扫描产品背贴码"></c-empty>
                    </template>

                    <c-table-column label="产品信息" width="300">
                        <template #default="{data}">
                            <m-product-info :name="data.product_name" :level="data.product_level" :code="data.produce_code" :imei="data.imei"></m-product-info>
                        </template>
                    </c-table-column>
<!--					<c-table-column label="背贴码" width="120">-->
<!--						<template #default="{data}">{{data.produce_code || '-'}}</template>-->
<!--					</c-table-column>-->
<!--					<c-table-column label="IMEI" width="130">-->
<!--						<template #default="{data}">{{data.imei || '-'}}</template>-->
<!--					</c-table-column>-->
					<c-table-column label="成本价" width="100">
						<template #default="{data}">{{data.cost_price !== null && data.cost_price !== undefined && data.cost_price !== '' ? '¥' + data.cost_price : '-'}}</template>
					</c-table-column>
					<c-table-column label="销售价" width="130" required>
						<template #default="{data}">
							<c-input type="number" decimal="2" :range="[0, 99999999]" :value="data.sale_price" @input="onFieldInput(data, 'sale_price', $event)" placeholder="请输入" append-text="元"></c-input>
						</template>
					</c-table-column>
					<c-table-column label="售卖类型" width="110">
						<template #default="{data}">
							<c-select :options="sellTypeOptions" v-model="data.sell_type" @change="onSellTypeChange(data, data.sell_type)"></c-select>
						</template>
					</c-table-column>
					<c-table-column label="拆机项" width="300">
						<template #default="{data}">
                            <c-select v-if="data.sell_type == 2" :options="DISMANTLE_ITEM" :value="data.dismantle_items" :multiple="{linefeed: true}" @change="onDismantleItemsChange(data, $event)" placeholder="请选择拆机项"></c-select>
							<span v-else>-</span>
						</template>
					</c-table-column>
					<c-table-column label="操作" width="80" type="button">
						<template #default="{data}">
							<c-table-button color="red" icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</c-form-item>
		</c-form>

		<!-- 底部按钮 -->
		<template #button>
			<c-button size="dialog" color="main" @click="submitHandle">确定</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	import {asyncMapState} from '@/store'
	export default {
		name: 'offlineOrderEdit',

		data() {
			return {
				orderId: '',
                orderNo: '',
				customerId: '',
				//编辑时客户回显选项
				customerOptions: [],
				remark: '',
				scanCode: '',
				productList: [],
				sellTypeOptions: [{
					name: '整机',
					value: 1
				}, {
					name: '拆机',
					value: 2
				}],
			}
		},

		computed: {
			...asyncMapState(['DISMANTLE_ITEM'])
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				this.orderId = data.orderId;
                this.orderNo = data.orderNo;
				this.customerId = '';
				this.customerOptions = [];
				this.remark = '';
				this.scanCode = '';
				this.productList = [];
				this.$store.dispatch('getAsyncDict', 'DISMANTLE_ITEM');
				this.$refs.dialog.open({title: this.orderId ? '编辑售出订单【' + this.orderNo + '】' : '新建售出订单'});
				if (this.orderId) {
					this.loadDetail();
				} else if (data.codes && data.codes.length) {
					/**商品管理列表快捷开单：按背贴码批量预填明细，走与手工扫码相同的后端校验*/
					this.loadByCodes(data.codes);
				} else {
					this.focusInput();
				}
			},

			/*********按背贴码批量加载商品明细（用于列表快捷开单）**********/
			loadByCodes(codes) {
				var list = codes || [];
				var index = 0;
				var next = () => {
					if (index >= list.length) {
						this.focusInput();
						return;
					}
					var code = list[index++];
					if (this.productList.some(item => item.produce_code == code)) {
						next();
						return;
					}
					this.request({
						url: '/productCode/queryByCode',
						data: {
							produce_unique_code: code,
							query_type: 'sale'
						},
						success: data => {
							this.productList.push({
								produce_code: data.produce_unique_code || code,
								imei: data.produce_imei || '',
								product_name: data.product_info || this.getProductText(data),
								product_level: data.level_type,
								cost_price: data.cost_price,
								/**销售价默认取小黑靓机渠道售价，该商品无渠道定价时为空由开单人自行填写*/
								sale_price: data.channel_sale_price || '',
								sell_type: 1,
								dismantle_items: []
							});
							next();
						},
						fail: msg => {
							this.$message({message: '背贴码【' + code + '】' + (msg || '加载失败'), type: 'warn'});
							next();
						}
					});
				};
				next();
			},

			/*********编辑时加载订单详情**********/
			loadDetail() {
				this.request({
					url: '/offline/sale/order/detail',
					data: {
						order_id: this.orderId
					},
					loading: true,
					success: data => {
						var order = data.order || {};
						this.customerId = order.customer_id;
						if (order.customer_id) {
							this.customerOptions = [{
								name: order.customer_name,
								value: order.customer_id
							}];
						}
						this.remark = order.remark || '';
						this.productList = (data.products || []).map(item => {
							return {
								produce_code: item.produce_code,
								imei: item.imei,
								product_name: item.product_name,
								product_level: item.level_type,
								cost_price: item.cost_price,
								sale_price: item.sale_price,
								sell_type: item.sell_type || 1,
								dismantle_items: this.parseDismantle(item.dismantle_items)
							};
						});
						this.focusInput();
					}
				});
			},

			/*********解析拆机项**********/
			parseDismantle(items) {
				if (!items) return [];
				try {
					var list = typeof items == 'string' ? JSON.parse(items) : items;
					if (!Array.isArray(list)) return [];
					// 从对象数组中提取 value 字段，如 [{"value":"4","name":"CPU"}] -> ["4"]
					return list.map(item => String(item.value || item));
				} catch (e) {
					return [];
				}
			},

			/*********聚焦扫码输入框**********/
			focusInput() {
				this.$nextTick(() => {
					var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			/*********搜索客户**********/
			searchCustomer(keyword, resolve) {
				this.request({
					url: '/sale/customer/options',
					data: {
						keyword: keyword,
						//售出订单只可选零售客户
						customer_type: 2
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.customer_name,
								value: item.id
							};
						}));
					}
				});
			},

			/*********新建客户**********/
			createCustomer() {
				//指定新建的客户固定为零售客户
				this.globalDialog('saleCustomerEdit', {
					props: {
						customer_type: 2
					}
				}, () => {
					if (this.$refs.customerSelect) {
						this.$refs.customerSelect.search('');
					}
				});
			},

			/*********扫码处理**********/
            scanHandle() {
                var code = this.scanCode.trim();
                if (!code) {
                    this.$message({message: '请输入背贴码', type: 'warn'});
                    return;
                }
                // 编辑模式下仅限一条商品
                if (this.orderId && this.productList.length >= 1) {
                    this.$message({message: '编辑模式下仅支持一条商品明细', type: 'warn'});
                    this.scanCode = '';
                    this.focusInput();
                    return;
                }
                if (this.productList.some(item => item.produce_code == code)) {
                    this.$message({message: '该背贴码已添加', type: 'warn'});
                    this.scanCode = '';
                    this.focusInput();
                    return;
                }
				this.request({
					url: '/productCode/queryByCode',
					data: {
						produce_unique_code: code,
                        query_type: 'sale'
					},
					loading: true,
					success: data => {
						this.productList.push({
							produce_code: data.produce_unique_code || code,
							imei: data.produce_imei || '',
							product_name: data.product_info || this.getProductText(data),
							product_level: data.level_type,
							cost_price: data.cost_price,
							//销售价默认取小黑靓机渠道售价，该商品无渠道定价时为空由开单人自行填写
							sale_price: data.channel_sale_price || '',
							sell_type: 1,
							dismantle_items: []
						});
						this.scanCode = '';
						this.focusInput();
					},
					fail: msg => {
						this.$message({message: msg, type: 'warn'});
						this.scanCode = '';
						this.focusInput();
					}
				});
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********行内字段更新**********/
			onFieldInput(data, field, val) {
				var item = this.productList.find(item => item.produce_code == data.produce_code);
				if (item) this.$set(item, field, val);
			},

			/*********切换售卖类型**********/
			onSellTypeChange(data, val) {
				var item = this.productList.find(item => item.produce_code == data.produce_code);
				if (item) {
					this.$set(item, 'sell_type', val);
					if (val != 2) this.$set(item, 'dismantle_items', []);
				}
			},

			/*********更新拆机项**********/
			onDismantleItemsChange(data, val) {
				var item = this.productList.find(item => item.produce_code == data.produce_code);
				if (item) {
					this.$set(item, 'dismantle_items', val || []);
				}
			},

			/*********移除单项**********/
			removeItem(data) {
				this.productList = this.productList.filter(item => item.produce_code != data.produce_code);
				this.focusInput();
			},

			/*********提交**********/
			submitHandle() {
				if (!this.customerId) {
					this.$message({message: '请选择销售客户', type: 'warn'});
					return;
				}
				if (!this.productList.length) {
					this.$message({message: '请至少添加一个商品', type: 'warn'});
					return;
				}
				for (var item of this.productList) {
					var price = parseFloat(item.sale_price);
					if (isNaN(price) || price <= 0) {
						this.$message({message: '背贴码【' + item.produce_code + '】的销售价必须大于0', type: 'warn'});
						return;
					}
					if (item.sell_type == 2 && !(item.dismantle_items || []).length) {
						this.$message({message: '背贴码【' + item.produce_code + '】请选择拆机项', type: 'warn'});
						return;
					}
				}
				var data = {
					customer_id: this.customerId,
					products: JSON.stringify(this.productList.map(item => {
						var row = {
							produce_code: item.produce_code,
							sale_price: parseFloat(item.sale_price),
							sell_type: item.sell_type || 1
						};
						if (item.sell_type == 2) {
							row.dismantle_items = JSON.stringify(item.dismantle_items);
						}
						return row;
					})),
					remark: this.remark
				};
				if (this.orderId) data.order_id = this.orderId;
				this.request({
					url: this.orderId ? '/offline/sale/order/edit' : '/offline/sale/order/create',
					data: data,
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || (this.orderId ? '编辑成功' : '创建成功'), type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			},

			/*********关闭弹框**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-dialog-body {
		padding: 0 20px;
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}

	.m-form-row {
		display: flex;
		align-items: flex-start;
		gap: 40px;
		margin-bottom: 16px;
		margin-top: 16px;
	}

	.m-form-item {
		flex: 1;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}

		.m-select-wrap {
			display: flex;
			align-items: center;
			gap: 8px;

			.m-link {
				flex-shrink: 0;
				font-size: 13px;
				color: #1890ff;
				cursor: pointer;
				white-space: nowrap;

				i {
					margin-right: 2px;
				}

				&:hover {
					color: #40a9ff;
				}
			}
		}
	}

	.m-detail-card {
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: hidden;
	}

	.m-toolbar {
		padding: 10px 16px;
		background: #fafafa;
		border-bottom: 1px solid #e8e8e8;
		gap: 10px;
	}

	.m-empty-state {
		padding: 60px 0;
		text-align: center;
		color: #999;

		p {
			font-size: 14px;
		}
	}

	.m-dismantle-checks {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
	}

	.m-check-tag {
		display: inline-block;
		padding: 2px 8px;
		font-size: 12px;
		border: 1px solid #d9d9d9;
		border-radius: 2px;
		cursor: pointer;
		color: #333;
		background: #fafafa;
		user-select: none;
		line-height: 20px;

		&:hover {
			border-color: #3D5EFF;
			color: #3D5EFF;
		}

		&.z-active {
			background: #3D5EFF;
			border-color: #3D5EFF;
			color: #fff;
		}
	}
</style>
